import { Controller } from "stimulus"

const LEAVING_PAGE_MESSAGE = "Estas intentando salir de la pagina sin guardar cambios. ¿Estas seguro?"

export default class extends Controller {
  static targets = ['save'];

  formIsChanged(event) {
    this.setChanged("true")
    if (this.saveTarget.classList.contains('hidden')) {
      this.saveTarget.classList.toggle('hidden');
    }
  }

  leavingPage(event) {
    if (this.isFormChanged()) {
      if (event.type == "turbolinks:before-visit") {
        if (!window.confirm(LEAVING_PAGE_MESSAGE)) { 
          event.preventDefault()
        }
      } else {
        event.returnValue = LEAVING_PAGE_MESSAGE;
        return event.returnValue;
      }
    } 
  }

  allowFormSubmission(event) {
    this.setChanged("false")
  }

  setChanged(changed) {
    this.data.set("changed", changed)
  }

  isFormChanged() {
    return this.data.get("changed") == "true";
  }
}